module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    staticClass: "gray"
  }, [_vm._v("one")]), _c('br'), _c('br'), _vm._v("The Baby Boom")]), _vm._v(" "), _c('p', {
    staticClass: "chaptit"
  }, [_vm._v("The Self-Involved Glacier")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recovering from the Great Depression and fighting World War II focused American society’s attention elsewhere than on its young people. During the Depression, each American family generated 2.1 births, barely a replacement level of fertility. The ensuing war finally spurred the economy, but it separated families and created uncertainty about the future. Societies experiencing such crises do not create many children: couples without children postpone forming families, while families with children concentrate on feeding and sheltering the ones they already have.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The baby boom generation, in contrast, was conceived in optimism—the euphoric aftermath of global triumph over the Axis powers. Though the rise of the Soviet Union cast a shadow over this triumph, the menacing uncertainty of World War II gave way to a U.S. economic rebirth with seemingly limitless possibilities for its young families. Returning veterans reunited with their spouses, returned to school, and began making babies at a furious pace. During the baby boom, Americans’ fertility rate increased to an astounding 3.8 births per family and resulted in a 44 percent increase in the U.S. population ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig01"
    }
  }, [_vm._v("figure 1.1")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01fig01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Figure 1.1.")]), _vm._v(" The U.S. postwar baby boom"), _c('br'), _c('em', [_vm._v("Source:")]), _vm._v(" Data from U.S. Census Bureau.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Straining Capacity")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new American family and its needs became the central preoccupation of not only merchants and advertisers but also the popular culture and society. As the baby boom unfolded, the United States was confronted with a massive, rolling capacity problem: how to feed, house, educate, and eventually employ 76 million new people. Making room for the baby boom proved to be a major economic and domestic policy challenge in the years following World War II.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The expansion of elementary education became the most pressing item on the agenda of local government. About 45 percent of all existing public schools were built between 1950 and 1969."), _c('a', {
    attrs: {
      "id": "ch01fnote01"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn01",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" In the 1960s and 1970s, America’s higher educational institutions, public and private, had to execute a similar dramatic expansion to handle the flood of students. Between 1960 and 1980, the number of college students more than quadrupled, from 2.9 million to 12.4 million."), _c('a', {
    attrs: {
      "id": "ch01fnote02"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn02",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" This expansion was not merely a matter of many more people of college age but also a marked increase in their participation rate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The proportion of baby boomers who graduated from college was far higher than that of their parents’ generation."), _c('a', {
    attrs: {
      "id": "ch01fnote03"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn03",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" As late as the 1940s, only 5 percent of the U.S. population aged 25 or older had attained a bachelor’s degree or higher; only 25 percent had graduated from high school!"), _c('a', {
    attrs: {
      "id": "ch01fnote04"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn04",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" By 1980 high school graduation rates had risen to 67 percent, and 27 percent of the baby boomers went on to achieve a bachelor’s degree or higher. From 1940 to 1990, the number of college graduates in the United States grew almost tenfold, from 3.4 million to 32.3 million."), _c('a', {
    attrs: {
      "id": "ch01fnote05"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn05",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" This higher educational level has had important implications for baby boomers, and, as will be later discussed, it will influence how effectively they manage their health risks as they age.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As baby boomers graduated, they flooded the labor market with an unprecedented number of people with college or advanced degrees. Baby boomers became the shock troops for a new, knowledge-based economy. Two long economic expansions, interrupted by economic troubles from 1973 to 1981, provided the working capital to fund the expansion of the U.S. work force to accommodate the baby boom generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("The last phase of this economic expansion was accomplished in the face of a sudden quintupling of energy prices in the wake of the 1973 Arab oil embargo. After a pullback in energy prices in the mid-1970s, there was a less vertiginous but still significant energy price increase in the wake of the Iranian Islamic revolution at the end of the decade. The onset of the Iran-Iraq War in 1980 pushed oil prices to a 2005 equivalent price of more than $100 a barrel and gasoline prices to more than $3.50 a gallon."), _c('a', {
    attrs: {
      "id": "ch01fnote06"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn06",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the economy to absorb these two huge energy price shocks and nevertheless create 34 million new jobs in twenty years stands as perhaps the most significant unacknowledged economic miracle of the late twentieth century. Of course, what enabled this miracle was the fact that the baby boom generation itself created explosive growth in demand for every product and service you could think of: real estate and automobiles, household appliances and clothing, computers and electronic gadgets. In turn, this new demand created the jobs that employed the people consuming the products. The remarkable U.S. economic growth in the 1980s and 1990s was “powered by boomers.”")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Dominating Popular Culture")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The baby boom ruthlessly monopolized American popular culture. Baby boomers (and their young parents) became the first mass market for the emerging American television industry. Television shaped the popular images that held boomers mesmerized in their childhood and adolescence, as well as created a mass retail market for new consumer products. The television-viewing audience, with only 4.4 million people owning television sets in 1950, grew to 50 million in one explosive decade."), _c('a', {
    attrs: {
      "id": "ch01fnote07"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn07",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tens of millions of Americans, children and parents, watched the "), _c('em', [_vm._v("Lone Ranger")]), _vm._v(" and "), _c('em', [_vm._v("Superman, Captain Kangaroo")]), _vm._v(" and the "), _c('em', [_vm._v("Mickey Mouse Club,")]), _vm._v(" and "), _c('em', [_vm._v("Rocky and Bullwinkle.")]), _vm._v(" They experienced the siege of the Alamo and bought Davy Crockett faux coonskin caps; attended Disney’s animated full-length feature films, such as "), _c('em', [_vm._v("Cinderella, Sleeping Beauty,")]), _vm._v(" and "), _c('em', [_vm._v("101 Dalmatians;")]), _vm._v(" and visited Disney’s theme parks. Television "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("also introduced to boomers a new generation of musical performers, future pop culture icons such as Elvis Presley and the Beatles. These new stars catalyzed the growth of a modern entertainment industry, whose stars commanded the attention of the world’s youth. Interestingly, the highest-grossing rock music acts in 2005–2006 were all either boomers themselves, such as Madonna and U2, or older musicians, such as Eric Clapton, Paul McCartney, and the Rolling Stones, whom boomers had listened to in their teens and twenties."), _c('a', {
    attrs: {
      "id": "ch01fnote08"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn08",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The new Interstate Highway System, whose construction began in 1955, enabled baby boomers to become the most mobile and geographically liberated generation of Americans. Not only did the Interstate system enable rapid intercity movement but it also provided the transportation framework for an astonishing expansion of suburban housing, enabling the boomers’ parents to relocate by the millions to the suburbs and yet remain accessible to the city for work and leisure. Cars became central to baby boomers’ lives, particularly as adolescents and young adults. Baby boomers grew up in their family cars and, as they aged, they took advantage of markedly improved physical access to explore their country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Interstate Highway System not only catalyzed economic growth and enabled the emergence of dispersed employment sites but also enabled a cosmopolitan, restless, and highly mobile generation of young Americans. No longer confined to a city neighborhood or a town, as their parents and grandparents had been, baby boomers were able to experience the breadth and diversity of the vast American continent.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Steeped in Politics")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Political consciousness and activism shaped the values of this enormous and influential generation. Baby boomers grew up in the shadow of nuclear holocaust, hostages to the terrifying nuclear standoff between the United States and the Soviet Union. To characterize it as a “cold war” does not do justice to its psychic impact. Baby boomers learned at an early age that they and their families could literally be vaporized in a sudden firestorm of atomic war. They were "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("taught to cower under their school desks in “duck and cover” drills, as well as to listen for the high-pitched whine of a Civil Defense alert on their transistor radios, which could signal the end of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seeking social justice for the oppressed was central to the baby boom political agenda."), _c('a', {
    attrs: {
      "id": "ch01fnote09"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn09",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Older baby boomers heard John Kennedy’s stirring call to action in his 1961 inaugural address: “Ask not what your country can do for you. Ask what you can do for your country.” The boomers’ older brothers and sisters initiated political protests over civil rights, particularly voting rights, access to public education, and freedom from discrimination in the workplace for black Americans. This activism gave rise to a mass political movement and forced the Johnson administration and Congress to intervene and guarantee voting rights and access to education for minorities. This movement shortly produced a welter of new federal programs to attack both rural and urban poverty. As Leonard Steinhorn argued in his 2006 book, "), _c('em', [_vm._v("The Greater Generation,")]), _vm._v(" baby boomers have not been sufficiently credited for their role in fostering a commitment to social justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though some of its leaders, such as Betty Friedan and Gloria Steinem, were older, baby boom women were the foot soldiers of the women’s movement, which demanded and secured women’s rights in the workplace, family, and society at large. By redefining women’s priorities to encompass careers and the freedom to decide when or whether to have children, this feminist revolution fundamentally reshaped the American workplace and family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baby boom women also catalyzed a revolution in women’s health, symbolized by the publication in 1970 of "), _c('em', [_vm._v("Our Bodies, Ourselves,")]), _vm._v(" a book that encouraged women to reshape the health services they used to meet their own and their children’s needs, rather than simply to obey the health care system’s dictates."), _c('a', {
    attrs: {
      "id": "ch01fnote10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn10",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v(" The feminist revolution thus gave rise to a consumer movement in health care, which helped level the sharp gradient in power and knowledge between patients and their physicians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, the baby boom also represented a demographic resource for politicians—a massive cohort of military-aged young people that swelled U.S. military power. Dramatic escalation of the "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Vietnam conflict came in 1965, the year in which, by grisly coincidence, the leading edge of the baby boom generation reached military age. This unpopular war against a resourceful enemy killed more than 58,000 young Americans—boomers and their older brothers and sisters (compared to about 3,300 dead in the first four years of the U.S. expedition in Iraq). More than 3 million soldiers rotated through Vietnam during the thirteen-year-long war, and more than 300,000 brought home injuries that scarred them for life."), _c('a', {
    attrs: {
      "id": "ch01fnote11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn11",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Vietnam War altered the life course and shaped the political values of an entire generation of young men. Every male boomer born before 1957 was touched in some way by the military draft and the prospect of being sent to Vietnam. Between 50,000 and 100,000 young Americans fled to Canada to avoid the draft."), _c('a', {
    attrs: {
      "id": "ch01fnote12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn12",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("12")])]), _vm._v(" Millions of others hid out in college or graduate school, intentionally crafted shelters from the draft, or in public service jobs that brought them draft deferments.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The Cultural Tyranny of the 1960s")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the first baby boomers reached their teens in the mid-1960s, the United States experienced a surge of violent crime ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig02"
    }
  }, [_vm._v("figure 1.2")]), _vm._v(") and an even more shocking wave of mass urban violence in its largest cities; Detroit, Chicago, Los Angeles, and Newark experienced the most extensive damage. Some of the cities that went up in flames during the middle 1960s, such as Detroit and Newark, have never recovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nation’s divorce rate also surged in the 1960s ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig03"
    }
  }, [_vm._v("figure 1.3")]), _vm._v("), coincident with the baby boom’s reaching the age of family formation. This sharp generational discontinuity had far-ranging implications for the shape of the American family and for the lives of baby boomers’ children, an increasing proportion of whom lived in one-parent families. A surge in children born out of wedlock paralleled this trend. The disintegration of the nuclear family and rising crime and violence contributed to a sense that U.S. society was unraveling before our eyes. A wave of political controversy and recrimination ensued, which is, remarkably, still going on some forty years later.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01fig02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Figure 1.2.")]), _vm._v(" U.S. violent crime index, 1960–2005"), _c('br'), _c('em', [_vm._v("Source:")]), _vm._v(" Data from FBI Uniform Crime Reports.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Americans are still angrily debating what happened during the 1960s. The rising crime and divorce rates, as well as rising births out of wedlock, were cited by conservative social critics as signposts of cultural decadence and moral decline."), _c('a', {
    attrs: {
      "id": "ch01fnote13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn13",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" The 1960s were not a uniquely American cultural phenomenon. Other countries, notably France, Germany, and China, experienced wrenching cultural upheaval during the same period, fired by the coming of age of a large generation of postwar children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone in American society experienced the turbulence of the baby boomers’ adolescence whether they wished to or not—initially their parents and grandparents and now, in an unwelcome cultural echo, baby boomers’ own children. Many Generation X’ers, who were born between 1965 and 1990, resent the cultural tyranny of the 1960s and the grip boomers seem to have on the cultural imagination. Paul Begala, a former aide in the Clinton White House and now a television pundit, once referred to the baby boom generation as “a giant garbage scow.” In the definitive novel that coined the term “Generation X,” Douglas Coupland inveighed against self-involved boomer parents, whose children toiled in what he called McJobs that led nowhere, while increased costs of living made it impossible for them to live independently."), _c('a', {
    attrs: {
      "id": "ch01fnote14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn14",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01fig03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Figure 1.3.")]), _vm._v(" U.S. divorce rate, 1950–2001"), _c('br'), _c('em', [_vm._v("Source:")]), _vm._v(" Data from U.S. Census Bureau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An irritating assumption by social observers of the baby boom is the unvoiced belief that the baby boomers were then and are today culturally "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("and politically homogeneous. This is manifestly false. Not every boomer protested against the Vietnam War or against the oppression of minorities or discrimination against women. Indeed, even today, baby boomers split fifty-fifty on whether entering the Vietnam War was a mistake and whether losing it was merely a failure of national will."), _c('a', {
    attrs: {
      "id": "ch01fnote15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn15",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" The political reaction to the Vietnam War and the darkening of American culture split the society, including boomers themselves, and created a cultural division that has become, even with the passage of four decades, the principal “values” cleavage in U.S. politics.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Suspicious of Power")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baby boomers grew up suspicious of political power. The most enduring and pervasive political attitude of boomers for more than thirty years has been the high level of mistrust of politicians and institutions. Political attitudes of baby boomers’ parents were shaped in the crucible of the Great Depression and World War II. Memories of a successful societal mobilization against the Depression and defeat of a frightening global military foe left in boomers’ parents the residue of strong faith in U.S. political institutions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Political values of baby boomers, on the other hand, were forged in a climate of disillusionment and mistrust. The Vietnam conflict had a personal effect on virtually every male boomer who is currently older than 50 and on his younger brothers and sisters indirectly. Vietnam, a war expanded stealthily by Lyndon Johnson and lengthened furtively by Richard Nixon, permanently colored attitudes toward governmental authority and truthfulness. This suspicion finds powerful echoes in the widespread unpopularity of the war in Iraq.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Watergate crisis, which drove President Richard Nixon from office, further reinforced baby boomers’ beliefs that political power served merely its own ends and is reliably abused. Only 32 percent of boomers surveyed in 2004—thirty long years after Watergate—believed that government “will do what is right most of the time.”"), _c('a', {
    attrs: {
      "id": "ch01fnote16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn16",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These two events—the Vietnam War and Watergate—had a powerful catalytic effect on boomers’ political attitudes. Division over the Vietnam War and the backlash against the civil rights and abortion "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("rights movements not only split baby boomers but also shattered the Democrats’ New Deal coalition, separating many working-class whites, Catholics, and southerners from the party. Beginning in 1976, a succession of presidential candidates of both political parties successfully campaigned, directly or indirectly, against the federal government. This culminated in President Clinton’s remarkable (and insincere) pronouncement in his 1996 State of the Union address that the “era of big government is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is impressive how durable baby boomers’ mistrust of government has been. In 1970 public opinion surveys found that a minuscule 3 percent of boomers were “very confident” in statements made by government leaders. With the benefit of thirty years’ experience, the proportion of boomers surveyed in 2002 who said they were highly confident in the veracity of government statements grew to a whopping 6 percent. Boomers highly confident in Congress actually fell (from 16% to 13%) in the ensuing thirty years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mistrust of politicians and politics may be responsible for changing voter participation patterns as baby boomers entered the political system. Two major changes in political participation coincided with baby boomers’ becoming enfranchised: the emergence of a large bloc of so-called independent voters, and the decline in voter participation rates ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig04"
    }
  }, [_vm._v("figure 1.4")]), _vm._v("). Both of these trends accelerated markedly after "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("1971, when the Twenty-sixth Amendment to the U.S. Constitution lowered the voting age from 21 to 18.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01fig04"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Figure 1.4.")]), _vm._v(" Voter participation, 1964–2004"), _c('br'), _c('em', [_vm._v("Source:")]), _vm._v(" Data from U.S. Census Bureau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Today, independent voters outnumber members of either political party. Independent voters and nonvoters together comprise a majority of the voting-age U.S. population. How the nonaligned voters behave determines in large measure which major party’s candidates prevail in state or national elections ("), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01fig05"
    }
  }, [_vm._v("figure 1.5")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baby boomers are the core of a large and resource-rich pool of potential supporters for future third-party presidential candidates and potentially a third political party. In a 2004 poll taken for AARP, 56 percent of boomers said they believed the country needs a strong third party, compared to 37 percent of their parents’ generation."), _c('a', {
    attrs: {
      "id": "ch01fnote17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn17",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" The same survey found that 16 percent of baby boomers were not registered to vote, double the number of their parents’ or grandparents’ generation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boomers mistrust concentrated power of all kinds, not merely political institutions. They are truly the children of Thomas Jefferson. Only 22 percent of baby boomers surveyed in 2002 expressed a great deal of confidence in corporate leaders, 20 percent in those running colleges and universities, and 13 percent in leaders of organized religion."), _c('a', {
    attrs: {
      "id": "ch01fnote18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn18",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("18")])]), _vm._v(" Since the 1970s, confidence by baby boomers rose in only two institutions: the military and, remarkably, the executive branch. Because Richard Nixon had been president in the early 1970s, the modest rise in trust in the executive branch is at least somewhat comprehensible. This has almost certainly dissipated in the past five years owing to widespread disillusionment over the war in Iraq and rising hostility to the Bush presidency. The end of the military draft may have elevated baby boomers’ esteem of this once feared institution.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boomers’ suspicion of power has been institutionalized in a strong investigative press, both print and television. Courageous investigative reporters unearthed the Pentagon Papers and drove the hated Richard Nixon from office. The Internet has unleashed a new generation of resourceful freelance journalists, the bloggers, upon the wealthy and powerful. A major impact of an aggressively populist digital, broadcast, and print media has been to reinforce the public’s belief that power and wealth corrupt those who possess them.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch01fig05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0021-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Figure 1.5.")]), _vm._v(" Increase in independent voters, 1952–2000"), _c('br'), _c('em', [_vm._v("Source:")]), _vm._v(" Data from the National Election Studies, 1948–2002 National Election Studies Cumulative Data File.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("Personal Optimism: The Defining Character Trait of Baby Boomers")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The disjunction between personal optimism and profound cynicism about the political system is a striking feature of baby boomer attitudes. If you were to crystallize a single defining character trait of baby boomers, it would be optimism about their personal lives. In a 2003 survey, 67 percent of older boomers and 80 percent of younger boomers believed that their lives would be better in five years, compared to only 37 percent of older Americans."), _c('a', {
    attrs: {
      "id": "ch01fnote19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn19",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Only 5 percent of older boomers and 1 percent of younger boomers believed their lives would be worse in five years than today. The fact that most baby boomers have experienced only one serious recession in their adult lifetime (1979–81) may have fostered this optimism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baby boomers have already outdistanced their parents economically. On average, they have achieved higher incomes and accumulated more wealth."), _c('a', {
    attrs: {
      "id": "ch01fnote20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn20",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" However, as they usually do, these averages conceal significant disparities. While the top 20 percent of the boomers have a median net worth of $766,000, the bottom 20 percent have a median net worth of only about $1,500. Almost 7 percent of boomer households have zero or negative net worth."), _c('a', {
    attrs: {
      "id": "ch01fnote21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn21",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite this disparity of life circumstances and despite the turmoil of the Iraq war and post-9/11 uncertainties about our security, an extraordinary 82 percent of baby boomers surveyed in 2004 professed a great deal of satisfaction with the way things are going in their lives (including a remarkable 68% of those with household incomes below $25,000 per year). Sixty-nine percent of baby boomers strongly agreed with the statement, “What happens to me in the future mostly depends on me,” and a comparable percentage agreed with the statement, “When I really want to do something, I usually find a way to succeed at it.”"), _c('a', {
    attrs: {
      "id": "ch01fnote22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn22",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For someone to reach the age of 50 with a faith in his or her personal future and power to achieve personal goals largely unimpaired by personal experience is a remarkable testimony to an almost genetically based optimism (as well as the durability of U.S. economic growth). This sunny optimism seems to be a uniquely American trait, which irritates many European colleagues and friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("The anomalous contrast between an almost religious faith in the boundless possibilities of their personal futures and a deep-seated mistrust of society’s major institutions complicates the task of political leadership. Baby boomers’ personal comfort with optimism seems to have influenced their choice of presidents. After an unhappy experience with the dour and gloomy Jimmy Carter, Americans have rewarded with second presidential terms three leaders (Reagan, Clinton, and George W. Bush) who, despite profound differences in their stated political agendas, mirrored that sunny boomer optimism and faith in the future.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This pervasive suspicion by baby boomers of government could well spell an end to so-called entitlement politics, with its plantation-style reliance of large voting blocs on powerful political patrons. Baby boomers might not be willing to raise taxes to fund government-sponsored benefits for themselves in coming years. Because a large enough proportion of baby boomers will still be working or depending on passive income, many would see a tax increase as hurting their own pocketbooks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As earlier discussed, boomer disillusionment with the political process has materially weakened both political parties, which have both struggled to find a way of communicating not only with boomers, but with even more disillusioned younger voters. Profound differences in life circumstances and needs within the baby boom generation may complicate efforts to find a unified political theme that engages all boomers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Boomers who have bombproof retirement funding and plentiful financial assets and home equity will most likely have much less interest in government “safety net” programs for the “elderly” than those who have no resources and compromised health status. This latter group, however, may contain a larger number of voters who have already disengaged from the political process and thus do not vote to express their economic interests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course, political attitudes will probably change as these issues become less theoretical and more immediate. AARP research found that faith by boomers in the solidity of Social Security and Medicare increased somewhat in the 1998–2003 period, perhaps conditioned "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("somewhat by the 2001 tech stock crash and advancing age of the older boomers. However, only 54 percent of boomers surveyed in 2003 were “very or somewhat confident that Social Security will be available for them when they retire,” and 47 percent were “very or somewhat confident” about Medicare availability."), _c('a', {
    attrs: {
      "id": "ch01fnote23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn23",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is worth remembering that the younger half of the boomers are solidly “midcareer” (e.g., in their 40s) and “old age” is still a long way off, both biologically and emotionally. Fifty-something boomers do not identify with their elders or do not think of themselves as “old.” Rather, 63 percent of them feel younger than their actual age."), _c('a', {
    attrs: {
      "id": "ch01fnote24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ch01fn24",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tracking changes in baby boomers’ political attitudes as they age will be a major preoccupation for pollsters and political scientists for the next several decades. However, that single-issue entitlement politics focused on protecting New Deal social guarantees will excite the same reflexive passions and loyalties among boomers as it did among their parents and grandparents is difficult to imagine, given what we now know about baby boomers’ attitudes toward government and political leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To assess how baby boomers will respond to the social safety net will require us to understand the political and economic promises made to an earlier generation of older Americans. It will help as well to appreciate how different the twenty-first-century U.S. economy and society are from that scary world of the 1930s, when so much of America’s promise almost blew away in a prairie dust storm. Much of the controversy over the economic impact of the aging of the baby boom stems from how boomers will interact with the “legacy” programs of the New Deal. That controversy is explicated in greater detail in the following chapters, along with some of the major flaws in the catastropharian thesis.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0